(function ($) {

	// On Dom Ready
	$(function () {
		alignHeroInner();
	});

	$(window).on('resize', function(){
		alignHeroInner();
	});

	function alignHeroInner(){
		let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		
		// ignore hero with centered search forms (used on intranet)
		if( $('.hero-searchform-wrap').length ){
			$('.hero-inner .page-title').addClass('loaded');
			return;
		}
		
		// change padding left at screen size >= 1600px
		if ( vw >= 1600 && ! $('body').hasClass('single-team-member')) {
			$('.hero-inner').each(function (index, element) {
				// get left position of this element
				let left = $('.site-header .header-navbar .site-logo').offset().left + ( $('.site-header .header-navbar .site-logo').width() / 2 );

				// check if .site-content-inner exists
				if ( $('.site-content-inner').length > 0 ) {
					left = $('.site-content-inner').offset().left;
				}

				$(element).find('.page-title').attr('style', 'padding-left:' + left + 'px');
				$(element).find('.pdf-link-wrap').attr('style', 'padding-left:' + left + 'px');
				$(element).find('.page-title').addClass('loaded');
			});
		} else {
			$('.hero-inner').each(function (index, element) {
				$(element).find('.page-title').removeAttr('style');
				$(element).find('.pdf-link-wrap').removeAttr('style');
			});
		}
	}

})(jQuery);
